import { registerFeature } from "lib/features"
import { isEnabled } from "lib/@components/feature"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { authoringRoute } from "authoring/routes/authoring.runtime"
import { appRoute } from "routes/app/home.runtime"
import {
    FEATURE_FLAG_LEGISLATION_RESOLUTIONS,
    LEGISLATION_RESOLUTIONS_DEMAND,
} from "./feature-flag-legislation-resolutions"
import { getLegislationResolutionsRootPath } from "./legislation-resolution-route-paths"
import { ResolutionsListPage } from "./resolutions-list-page"
import { ResolutionDetailPage } from "./resolution-detail-page"
import { hasDemand } from "lib/authorization/has-demand"

registerFeature({
    numericalId: 1004,
    id: FEATURE_FLAG_LEGISLATION_RESOLUTIONS,
    name: "Legislation Resolution Review",
    description: "AI-generated proposed changes to schedules based on identified legislation inconsistencies.",
    readyForBeta: false,
    readyForProduction: false,
    internalUseOnly: true,
})

appRoute.register("schedule-resolutions", <ResolutionsListPage $lazy />)
authoringRoute.register("schedule-resolutions", <ResolutionsListPage $lazy />)

appRoute.register("schedule-resolutions/:id", <ResolutionDetailPage $lazy />)
authoringRoute.register("schedule-resolutions/:id", <ResolutionDetailPage $lazy />)

registerConditionalPageNavigation(
    canAccessLegislationResolutions,
    getLegislationResolutionsRootPath("app"),
    "Legislation Resolutions",
    "mdi:file-check-outline",
    {
        group: "More",
        priority: 260,
    }
)

registerConditionalPageNavigation(
    canAccessLegislationResolutions,
    getLegislationResolutionsRootPath("authoring"),
    "Legislation Resolutions",
    "mdi:file-check-outline",
    {
        group: "More",
        priority: 260,
    }
)

function canAccessLegislationResolutions() {
    return (
        isEnabled(FEATURE_FLAG_LEGISLATION_RESOLUTIONS) &&
        hasDemand("user") &&
        hasDemand("!sharing") &&
        hasDemand(LEGISLATION_RESOLUTIONS_DEMAND)
    )
}
